import type AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { isSuccessStatusCode, HttpStatusCode } from 'owa-http-status-codes';
import { userDate } from 'owa-datetime';
import { AssetErrorType } from 'owa-timestream-asset-sdk';
import type { FileModifyInfo } from '../schema';
import { fetchDriveItemInternal } from 'owa-timestream-asset-sdk-filepicker';

/**
 * Fetches the last modified info for a given file.
 * @param providerType file provider type
 * @param sharedUrl the generated share url for a given file
 */
export async function getLastModifiedInfo(
    providerType: AttachmentDataProviderType,
    sharedUrl: string,
    onError?: (errorType: AssetErrorType) => void
): Promise<FileModifyInfo | null> {
    try {
        const response = await fetchDriveItemInternal(providerType, sharedUrl);
        if (isSuccessStatusCode(response!.Status!) && response.Body) {
            const { lastModifiedBy, lastModifiedDateTime } = JSON.parse(response.Body);
            return {
                lastModifiedBy: lastModifiedBy.user,
                lastModifiedDate: userDate(lastModifiedDateTime),
            };
        } else if (response!.Status === HttpStatusCode.NotFound) {
            onError?.(AssetErrorType.NotFound);
        } else if (
            response!.Status === HttpStatusCode.Unauthorized ||
            response!.Status === HttpStatusCode.Forbidden
        ) {
            onError?.(AssetErrorType.Unauthorized);
        }
    } catch (err) {
        return null;
    }

    return null;
}
